export const QUERY_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
}

export const MESSAGE_ROLES = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT'
}

export const MESSAGE_STATUS = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED'
}

export const COMPOSER_LOCATION = {
  HOME_PAGE: 'home_page',
  CHAT_PAGE: 'ask_calendly_chat'
}

export const QUERY_SOURCE_TYPE = {
  TEXT: 'text',
  SUGGESTION: 'ai_question'
}

export const SUGGESTED_PROMPTS = [
  { id: 1, text: 'Help me prepare for my next meeting.' },
  { id: 2, text: 'What are my action items from last week?' },
  { id: 3, text: 'What meetings do I have this week?' }
]

export const CHAT_SUGGESTIONS = []

/**
 * Mapping from tool call names to translation keys
 * These keys correspond to entries in the agent_hub.tool_calls section of en_only.yml
 */
export const TOOL_CALL_NAME_MAPPING = {
  // MR (Meeting Records) Tools
  get_invitees: 'publisher.agent_hub.tool_calls.get_invitees',
  get_invitees_question_responses: 'publisher.agent_hub.tool_calls.get_invitees_question_responses',
  get_multiple_meeting_summaries_and_optionally_transcript:
    'publisher.agent_hub.tool_calls.get_multiple_meeting_summaries_and_optionally_transcript',
  get_user_and_meetings_in_time_range_optionally_filter_by_emails:
    'publisher.agent_hub.tool_calls.get_user_and_meetings_in_time_range_optionally_filter_by_emails',
  get_person_to_person_meetings: 'publisher.agent_hub.tool_calls.get_person_to_person_meetings',
  get_meetings_with_summaries_time_email_filter: 'publisher.agent_hub.tool_calls.get_meetings_with_summaries_time_email_filter',
  get_meeting_prep_info: 'publisher.agent_hub.tool_calls.get_meeting_prep_info',
  search_user_meetings_by_title_in_time_range: 'publisher.agent_hub.tool_calls.search_user_meetings_by_title_in_time_range',
  search_meetings_with_summaries_by_title: 'publisher.agent_hub.tool_calls.search_meetings_with_summaries_by_title',

  // Scheduling Tools
  get_event_types: 'publisher.agent_hub.tool_calls.get_event_types',
  book_on_behalf: 'publisher.agent_hub.tool_calls.book_on_behalf',

  // Common Tools
  get_current_datetime: 'publisher.agent_hub.tool_calls.get_current_datetime',
  search_contacts_by_names_or_emails: 'publisher.agent_hub.tool_calls.search_contacts_by_names_or_emails',
  get_contact_details: 'publisher.agent_hub.tool_calls.get_contact_details',

  // CRM Tools
  list_contacts: 'publisher.agent_hub.tool_calls.list_contacts',
  create_contact: 'publisher.agent_hub.tool_calls.create_contact',
  update_contact: 'publisher.agent_hub.tool_calls.update_contact',
  delete_contact: 'publisher.agent_hub.tool_calls.delete_contact',
  get_contact_relationship_summary: 'publisher.agent_hub.tool_calls.get_contact_relationship_summary',

  // Help Center Tools
  get_help_center_article: 'publisher.agent_hub.tool_calls.get_help_center_article',

  // Switchboard Tools
  request_feature: 'publisher.agent_hub.tool_calls.request_feature'
}

/**
 * Minimum duration (in milliseconds) that a tool call message should be displayed
 * to avoid flickering when tool calls change rapidly
 */
export const TOOL_CALL_MIN_DISPLAY_DURATION_MS = 3000

/**
 * Maximum number of characters to display in a link badge before truncating
 */
export const LINK_BADGE_MAX_TEXT_LENGTH = 40

/**
 * Feature flags used by agent hub components
 */
export const FEATURE_FLAGS = {
  MEETING_HOVER_CARD: 'caf_meeting_hover_card_feature',
  MESSAGE_ATTACHMENTS: 'caf_message_attachments'
}
